var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8693 6.85675C51.6974 5.02814 54.1769 4.00055 56.7626 4H91.7261C94.3119 4 96.7919 5.02723 98.6204 6.85571C100.449 8.68419 101.476 11.1641 101.476 13.75V48.7135C101.476 51.2992 100.448 53.7787 98.6193 55.6068L56.1873 98.0388C53.9716 100.241 50.9747 101.476 47.8511 101.476C44.7274 101.476 41.7306 100.241 39.5148 98.0388L7.43731 65.9613C5.23555 63.7455 3.99978 60.7487 3.99978 57.625C3.99978 54.5013 5.23555 51.5045 7.43731 49.2888L49.8693 6.85675Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6636 33.25C73.3174 33.25 72.2261 32.1587 72.2261 30.8125C72.2261 29.4663 73.3174 28.375 74.6636 28.375C76.0098 28.375 77.1011 29.4663 77.1011 30.8125C77.1011 32.1587 76.0098 33.25 74.6636 33.25Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/Brand.c511464942e72f682d39acad07cd63bd.svg";
export { ForwardRef as ReactComponent };